var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPclServiceVanRepair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0069b1",
    d: "M3.55 5.9c-1.054 0-1.9.845-1.9 1.9v7.6h1.9a2.85 2.85 0 0 0 2.85 2.85 2.85 2.85 0 0 0 2.85-2.85h5.7a2.85 2.85 0 0 0 2.85 2.85 2.85 2.85 0 0 0 2.85-2.85h1.9v-3.8c0-1.054-.846-1.9-1.9-1.9L17.8 5.9H3.55m11.4 1.425h2.375L19.187 9.7H14.95V7.325m-8.55 6.65A1.425 1.425 0 0 1 7.825 15.4 1.425 1.425 0 0 1 6.4 16.825 1.425 1.425 0 0 1 4.975 15.4 1.425 1.425 0 0 1 6.4 13.975m11.4 0a1.425 1.425 0 0 1 1.425 1.425 1.425 1.425 0 0 1-1.425 1.425 1.425 1.425 0 0 1-1.425-1.425 1.425 1.425 0 0 1 1.425-1.425Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0069b1",
    d: "M.7 17.965h19v1.89h-6.65v2.85h-1.9v-2.85H4.5v-1.89z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPclServiceVanRepair);
export default __webpack_public_path__ + "static/media/PclServiceVanRepair.dce7c7097bd235c0e6b368efbd892653.svg";
export { ForwardRef as ReactComponent };